import React from 'react';
import { Navigate, useLocation } from 'react-router';
import PropTypes from 'prop-types';

import { APP_ROUTES } from '../route';
import { isSurveySession } from '../utils/helpers';

// `replace` is explicit because v6's <Navigate> pushes by default, whereas the
// v5 <Redirect> it replaces always replaced.
const SurveyRoute = ({ component: Component }) => {
  const location = useLocation();

  if (!isSurveySession()) {
    return <Navigate to={APP_ROUTES.ROOT} state={{ from: location }} replace />;
  }

  return <Component />;
};

SurveyRoute.propTypes = {
  component: PropTypes.any,
};

export default SurveyRoute;
